import {
    GET_USERS,
    GET_DETAIL_USER,
    GET_STATE_LOADING,
    GET_TYPES_IDENTIFICATION,
    GET_GENDERS,
    GET_CIVIL_STATUS,
    GET_TYPES_EPS,
    GET_TYPES_AFP,
    GET_TYPES_ARL,
    GET_TYPES_CCF,
    GET_USER_DETAIL_FIELDS,
    GET_USER_PRODUCT_DETAIL_FIELDS
} from "@/views/users/store/types.js";

import { getField } from "vuex-map-fields";

const getters = {
    [GET_USERS]: (state) => state.users,
    [GET_DETAIL_USER]: (state) => state.detailUser,
    [GET_STATE_LOADING]: (state) => state.loading,
    [GET_TYPES_IDENTIFICATION]: (state) => state.typesIdentification,
    [GET_GENDERS]: (state) => state.genders,
    [GET_CIVIL_STATUS]: (state) => state.civilStatus,
    [GET_TYPES_EPS]: (state) => state.listTypesEps,
    [GET_TYPES_AFP]: (state) => state.listTypesAfp,
    [GET_TYPES_ARL]: (state) => state.listTypesArl,
    [GET_TYPES_CCF]: (state) => state.listTypesCcf,
    [GET_USER_DETAIL_FIELDS]: (state) => getField(state.detailUser),
    [GET_USER_PRODUCT_DETAIL_FIELDS]: (state) => getField(state.detailUser),
};

export default getters;